<template>
  <esg-table-without-meta :fields="fields"
                          :items="items"
                          :filter="false"
                          max-height="300px"
                          size="sm">
    <template #cell(category)="{item, items, field, row, col, value}">
      <td v-if="item.rowspan">{{ value }}</td>
      <!--  더미 HTML 엘레멘트    -->
      <td v-else style="border-top: none"></td>
    </template>
  </esg-table-without-meta>
</template>

<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  name: "EnvironmentDataTable",
  components: {EsgTableWithoutMeta},
  data() {
    return {
      fields: [
        {name: 'category', label: '구분', list: true, type: 'String', grouped: true},
        {name: 'item', label: '항목', list: true, type: 'String',},
        {name: 'unit', label: '단위', list: true, type: 'String',},
        {name: '2021', label: '2021', list: true, type: 'Number',},
        {name: '2022', label: '2022', list: true, type: 'Number',},
        {name: '2023', label: '2023', list: true, type: 'Number',},
      ],
      items: [
        {category: 'Scope 1 (직접배출)', item: '배출량', unit: 'tCO2', '2021': 10000, '2022': 5000, '2023': 1000, rowspan: 2},
        {category: 'Scope 1 (직접배출)', item: '원단위', unit: 'tCO2/ton', '2021': 10, '2022': 7, '2023': 7},
        {category: 'Scope 2 (간접배출)', item: '배출량', unit: 'tCO2', '2021': 5000, '2022': 5443, '2023': 6533, rowspan: 2},
        {category: 'Scope 2 (간접배출)', item: '원단위', unit: 'tCO2/ton', '2021': 5, '2022': 4, '2023': 3},
        {
          category: '보고조직 배출총량 (Scope 1 + 2)',
          item: '배출량',
          unit: 'tCO2',
          '2021': 15000,
          '2022': 10443,
          '2023': 7533,
          rowspan: 2
        },
        {category: '보고조직 배출총량 (Scope 1 + 2)', item: '원단위', unit: 'tCO2/ton', '2021': 15, '2022': 11, '2023': 10},
        {
          category: '보고조직 경계 외 배출총량 (Scope 1 + 2)',
          item: '협력사 배출',
          unit: 'tCO2/ton',
          '2021': 1000,
          '2022': 1345,
          '2023': 1444,
          rowspan: 7
        },
        {
          category: '보고조직 경계 외 배출총량 (Scope 1 + 2)',
          item: '자재 조달',
          unit: 'tCO2/ton',
          '2021': 3000,
          '2022': 422,
          '2023': 4344
        },
        {
          category: '보고조직 경계 외 배출총량 (Scope 1 + 2)',
          item: '임직원 통근',
          unit: 'tCO2/ton',
          '2021': 30,
          '2022': 43,
          '2023': 43
        },
        {
          category: '보고조직 경계 외 배출총량 (Scope 1 + 2)',
          item: '임직원 출장',
          unit: 'tCO2/ton',
          '2021': 20,
          '2022': 23,
          '2023': 23
        },
        {
          category: '보고조직 경계 외 배출총량 (Scope 1 + 2)',
          item: '폐기물 처리',
          unit: 'tCO2/ton',
          '2021': 700,
          '2022': 646,
          '2023': 654
        },
        {category: '보고조직 경계 외 배출총량 (Scope 1 + 2)', item: '임대자산', unit: 'tCO2/ton', '2021': 45, '2022': 45, '2023': 45},
        {
          category: '보고조직 경계 외 배출총량 (Scope 1 + 2)',
          item: '합계',
          unit: 'tCO2/ton',
          '2021': 4795,
          '2022': 2524,
          '2023': 6553
        },
      ]
    }
  }
}
</script>